import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sedancabservicemumbai() {



    const cardData = {
"keyword": "Sedan Cab Service Mumbai",

"headingDescription":
  "Om Sai Cab offers reliable and comfortable Sedan Cab Service Mumbai for travelers looking for safe, affordable, and convenient local as well as outstation transportation solutions. Whether you need airport transfers, business travel, daily office commuting, family trips, railway station pickups, sightseeing tours, wedding transportation, or long-distance journeys, our sedan cab service ensures a smooth and stress-free travel experience across Mumbai and nearby destinations. With experienced drivers familiar with Mumbai traffic routes, highways, and major tourist locations, clean air-conditioned sedan cars maintained for maximum comfort, and transparent pricing with no hidden charges, we provide a dependable cab booking solution for every passenger. Our sedan fleet is ideal for solo travelers, couples, small families, and corporate clients seeking comfortable, fuel-efficient, and premium travel experiences in Mumbai.",

"topPlaces": [
  {
    "title": "Lonavala",
    "description": "Popular hill station near Mumbai known for Bhushi Dam, green valleys, waterfalls, and weekend trips."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Famous hill station in Maharashtra known for strawberries, viewpoints, and cool climate."
  },
  {
    "title": "Goa",
    "description": "India’s top beach destination famous for nightlife, beaches, water sports, and Portuguese heritage."
  },
  {
    "title": "Nashik",
    "description": "Religious and wine capital of India known for Trimbakeshwar Temple and vineyards."
  },
  {
    "title": "Shirdi",
    "description": "Holy pilgrimage town dedicated to Sai Baba attracting millions of devotees every year."
  },
  {
    "title": "Pune",
    "description": "Cultural and educational hub known for forts, IT parks, and pleasant weather."
  },
  {
    "title": "Aurangabad",
    "description": "Historic city famous for Ajanta & Ellora Caves, UNESCO World Heritage sites."
  },
  {
    "title": "Alibaug",
    "description": "Coastal town near Mumbai known for beaches, resorts, and weekend getaways."
  },
  {
    "title": "Kolhapur",
    "description": "Cultural city famous for Mahalaxmi Temple, Kolhapuri cuisine, and history."
  },
  {
    "title": "Ratnagiri",
    "description": "Scenic Konkan coastal destination known for beaches, mangoes, and forts."
  }
],



services: [
  {
    name: "Sedan Cab Service Mumbai",
    description: "Sedan cab service Mumbai provides reliable transportation with comfortable sedan vehicles for smooth local and outstation road journeys. Sedan cars ensure dependable city and highway travel suitable for airport transfers, executive travel, tourism trips, and family outings. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "Mumbai Sedan Cab Service",
    description: "Mumbai sedan cab service offers dependable transportation solutions with spacious and comfortable sedan vehicles for road travel. Sedan cars ensure smooth city and highway journeys suitable for airport transfers, business travel, tourism trips, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Mumbai. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "Sedan Taxi Service Mumbai",
    description: "Sedan taxi service Mumbai provides comfortable transportation for travelers planning smooth local and outstation road journeys. Sedan vehicles ensure reliable city and highway travel suitable for tourism travel, airport transfers, executive trips, and family outings. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient sedan taxi reservations."
  },
  {
    name: "Sedan Cab Booking Mumbai",
    description: "Sedan cab booking Mumbai service provides quick and convenient transportation reservations for travelers planning comfortable road journeys. Sedan vehicles ensure smooth city and highway travel suitable for tourism travel, airport transfers, family vacations, and executive journeys. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "Luxury Sedan Cab Mumbai",
    description: "Luxury sedan cab Mumbai service provides premium transportation with stylish and comfortable sedan vehicles for smooth road journeys. Luxury sedan cars ensure reliable city and highway travel suitable for executive travel, airport transfers, VIP transport, and tourism trips. Professional chauffeurs ensure dependable pickup and premium transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient luxury sedan reservations."
  },
  {
    name: "Mumbai Sedan Taxi",
    description: "Mumbai sedan taxi service offers reliable transportation for travelers planning comfortable city and outstation road journeys. Sedan vehicles ensure smooth highway and city travel suitable for airport transfers, executive trips, tourism travel, and family holidays. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient sedan taxi reservations."
  },
  {
    name: "Outstation Sedan Cab Mumbai",
    description: "Outstation sedan cab Mumbai service provides dependable long-distance transportation with comfortable sedan vehicles for intercity road journeys. Sedan cars ensure reliable highway travel suitable for tourism trips, business travel, family vacations, and pilgrimage tours. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient outstation sedan cab reservations."
  },
  {
    name: "Mumbai Airport Sedan Cab",
    description: "Mumbai airport sedan cab service provides direct airport transportation with comfortable sedan vehicles for smooth pickup and drop road journeys. Sedan cars ensure reliable city and highway travel suitable for airport transfers, executive travel, tourism trips, and family vacations. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available directly from airport terminals and nearby airport locations across Mumbai. Flexible booking options allow convenient airport sedan cab reservations."
  },
  {
    name: "Honda City Cab Service Mumbai",
    description: "Honda City cab service Mumbai provides premium transportation with luxury sedan vehicles for smooth local and outstation road journeys. Honda City cars ensure reliable city and highway travel suitable for executive trips, airport transfers, tourism travel, and family outings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Honda City cab reservations."
  },
  {
    name: "Honda City Taxi Mumbai",
    description: "Honda City taxi Mumbai service offers dependable transportation with stylish and comfortable sedan vehicles for smooth road travel. Honda City cars ensure reliable city and highway journeys suitable for airport transfers, executive travel, tourism trips, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Honda City taxi reservations."
  },
  {
    name: "Honda City on Rent Mumbai",
    description: "Honda City on rent Mumbai service provides premium transportation with luxury sedan vehicles for comfortable road journeys. Honda City cars ensure smooth city and highway travel suitable for executive travel, airport transfers, tourism trips, and business travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Honda City rental reservations."
  },
  {
    name: "Honda City Airport Cab Mumbai",
    description: "Honda City airport cab Mumbai service provides direct airport transportation with luxury sedan vehicles for smooth pickup and drop road journeys. Honda City cars ensure reliable city and highway travel suitable for airport transfers, executive journeys, tourism trips, and family travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available directly from airport terminals and nearby airport areas across Mumbai. Flexible booking options allow convenient Honda City airport cab reservations."
  },
  {
    name: "Honda City Outstation Cab Mumbai",
    description: "Honda City outstation cab Mumbai service offers premium long-distance transportation with luxury sedan vehicles for intercity road journeys. Honda City cars ensure smooth highway travel suitable for tourism trips, business travel, family holidays, and executive journeys. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Honda City outstation cab reservations."
  },
  {
    name: "Luxury Honda City Cab Mumbai",
    description: "Luxury Honda City cab Mumbai service provides stylish and premium transportation for travelers planning smooth local and outstation road journeys. Honda City vehicles ensure reliable city and highway travel suitable for executive travel, VIP transport, airport transfers, and tourism trips. Professional chauffeurs ensure dependable pickup and premium transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient luxury Honda City reservations."
  },
  {
    name: "Honda City Cab Booking Mumbai",
    description: "Honda City cab booking Mumbai service provides quick transportation reservations with luxury sedan vehicles for comfortable road journeys. Honda City cars ensure smooth city and highway travel suitable for airport transfers, executive trips, tourism travel, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Honda City cab reservations."
  },
  {
    name: "Mumbai Honda City Rental",
    description: "Mumbai Honda City rental service provides luxury sedan transportation for travelers planning stylish and comfortable road journeys. Honda City cars ensure reliable city and highway travel suitable for executive travel, tourism trips, airport transfers, and family holidays. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Honda City rental reservations."
  },
  {
    name: "Premium Sedan Cab Mumbai",
    description: "Premium sedan cab Mumbai service provides luxury transportation with comfortable sedan vehicles for smooth road journeys. Sedan cars ensure dependable city and highway travel suitable for airport transfers, executive travel, tourism trips, and family vacations. Professional chauffeurs ensure punctual pickup and premium transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient premium sedan cab reservations."
  },
  {
    name: "Swift Dzire Cab Service Mumbai",
    description: "Swift Dzire cab service Mumbai provides economical and comfortable transportation with sedan vehicles for smooth road journeys. Swift Dzire cars ensure reliable city and highway travel suitable for airport transfers, tourism travel, family outings, and executive trips. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Swift Dzire cab reservations."
  },
  {
    name: "Swift Dzire Taxi Mumbai",
    description: "Swift Dzire taxi Mumbai service offers dependable transportation with comfortable sedan vehicles for local and outstation road travel. Swift Dzire cars ensure smooth city and highway journeys suitable for tourism trips, airport transfers, business travel, and family holidays. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Swift Dzire taxi reservations."
  },
  {
    name: "Swift Dzire on Rent Mumbai",
    description: "Swift Dzire on rent Mumbai service provides reliable transportation with budget-friendly sedan vehicles for smooth road journeys. Swift Dzire cars ensure dependable city and highway travel suitable for airport transfers, tourism trips, executive travel, and family outings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Swift Dzire rental reservations."
  },
  {
    name: "Swift Dzire Airport Cab Mumbai",
    description: "Swift Dzire airport cab Mumbai service provides direct airport transportation with comfortable sedan vehicles for smooth pickup and drop road journeys. Swift Dzire cars ensure reliable city and highway travel suitable for airport transfers, tourism trips, executive journeys, and family vacations. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available directly from airport terminals and nearby airport areas across Mumbai. Flexible booking options allow convenient Swift Dzire airport cab reservations."
  },
  {
    name: "Swift Dzire Outstation Cab Mumbai",
    description: "Swift Dzire outstation cab Mumbai service offers dependable long-distance transportation with comfortable sedan vehicles for intercity road journeys. Swift Dzire cars ensure smooth highway travel suitable for tourism trips, business travel, family vacations, and pilgrimage tours. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Swift Dzire outstation cab reservations."
  },
  {
    name: "Toyota Etios Cab Service Mumbai",
    description: "Toyota Etios cab service Mumbai provides reliable transportation with comfortable sedan vehicles for smooth local and outstation road journeys. Toyota Etios cars ensure dependable city and highway travel suitable for airport transfers, executive trips, tourism travel, and family vacations. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Toyota Etios cab reservations."
  },
  {
    name: "Etios Taxi Mumbai",
    description: "Etios taxi Mumbai service offers dependable transportation with spacious sedan vehicles for smooth city and highway road travel. Toyota Etios cars ensure reliable journeys suitable for tourism travel, airport transfers, business trips, and family outings. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Etios taxi reservations."
  },
  {
    name: "Toyota Etios on Rent Mumbai",
    description: "Toyota Etios on rent Mumbai service provides reliable transportation with comfortable sedan vehicles for local and outstation road journeys. Toyota Etios cars ensure smooth city and highway travel suitable for airport transfers, tourism trips, executive travel, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Toyota Etios rental reservations."
  },
  {
    name: "Etios Sedan Cab Mumbai",
    description: "Etios sedan cab Mumbai service provides economical and comfortable transportation with spacious sedan vehicles for smooth road journeys. Toyota Etios cars ensure reliable city and highway travel suitable for airport transfers, tourism travel, family outings, and executive trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Etios sedan cab reservations."
  }
],

tableData: [
  ["Sedan Cab Service Mumbai", "Mumbai Sedan Cab Service"],
  ["Sedan Taxi Service Mumbai", "Sedan Cab Booking Mumbai"],
  ["Luxury Sedan Cab Mumbai", "Mumbai Sedan Taxi"],
  ["Outstation Sedan Cab Mumbai", "Mumbai Airport Sedan Cab"],
  ["Honda City Cab Service Mumbai", "Honda City Taxi Mumbai"],
  ["Honda City on Rent Mumbai", "Honda City Airport Cab Mumbai"],
  ["Honda City Outstation Cab Mumbai", "Luxury Honda City Cab Mumbai"],
  ["Honda City Cab Booking Mumbai", "Mumbai Honda City Rental"],
  ["Premium Sedan Cab Mumbai", "Swift Dzire Cab Service Mumbai"],
  ["Swift Dzire Taxi Mumbai", "Swift Dzire on Rent Mumbai"],
  ["Swift Dzire Airport Cab Mumbai", "Swift Dzire Outstation Cab Mumbai"],
  ["Toyota Etios Cab Service Mumbai", "Etios Taxi Mumbai"],
  ["Toyota Etios on Rent Mumbai", "Etios Sedan Cab Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Sedan Cab Service in Mumbai",
    WhyChoosedescription: "Om Sai Cab Service provides reliable sedan cab service in Mumbai with professional drivers, comfortable vehicles, and smooth travel for local rides, airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Affordable Sedan Taxi Fare in Mumbai",
    WhyChoosedescription: "Our Mumbai sedan taxi service offers affordable pricing with transparent fare details and no hidden charges for airport transfers, city travel, and outstation bookings."
  },
  {
    WhyChooseheading: "24/7 Sedan Cab Availability",
    WhyChoosedescription: "Om Sai Cab Service operates 24 hours a day for sedan cab bookings in Mumbai including airport pickups, railway station transfers, family travel, and business trips."
  },
  {
    WhyChooseheading: "Comfortable & Clean AC Sedan Cars",
    WhyChoosedescription: "All sedan taxis are fully air-conditioned, sanitized, spacious, and regularly maintained to provide smooth and comfortable travel experiences."
  },
  {
    WhyChooseheading: "Local & Outstation Sedan Cab Booking",
    WhyChoosedescription: "Customers can book sedan taxis for Mumbai local travel, airport transfers, one-way trips, round-trip journeys, sightseeing tours, and customized outstation travel packages."
  },
  {
    WhyChooseheading: "Multiple Sedan Vehicle Options Available",
    WhyChoosedescription: "Om Sai Cab Service offers Swift Dzire, Hyundai Aura, Honda Amaze, Tata Tigor, Etios, Honda City, and Maruti Ciaz sedan cars for comfortable travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup service from Mumbai Airport, Navi Mumbai, Thane, hotels, homes, railway stations, offices, and all major Mumbai locations."
  },
  {
    WhyChooseheading: "Experienced Drivers for Safe Travel",
    WhyChoosedescription: "Our experienced drivers are familiar with Mumbai city roads, airport routes, highways, and tourist destinations to ensure safe driving and timely travel."
  }
]
};

const faqData = [
  {
    question: "What is sedan cab service in Mumbai?",
    answer: "Sedan cab service in Mumbai provides comfortable taxi transportation using sedan cars for local travel, airport transfers, business rides, and outstation journeys."
  },
  {
    question: "Is sedan cab service available 24 hours in Mumbai?",
    answer: "Yes, Om Sai Cab Service provides 24/7 sedan taxi service in Mumbai."
  },
  {
    question: "Which sedan cars are available for booking?",
    answer: "Customers can choose Swift Dzire, Hyundai Aura, Honda Amaze, Tata Tigor, Etios, Honda City, and Maruti Ciaz sedan cars."
  },
  {
    question: "Can I book sedan cabs for outstation travel from Mumbai?",
    answer: "Yes, customers can book sedan cabs for one-way and round-trip outstation travel from Mumbai."
  },
  {
    question: "Do you provide Mumbai Airport pickup and drop with sedan cars?",
    answer: "Yes, Om Sai Cab Service provides airport pickup and drop service using comfortable sedan taxis."
  },
  {
    question: "Are all sedan taxis air-conditioned?",
    answer: "Yes, all sedan taxis are fully air-conditioned and maintained for comfortable travel."
  },
  {
    question: "Can I book sedan cab service online in Mumbai?",
    answer: "Yes, customers can easily book sedan cab service online or through phone booking."
  },
  {
    question: "Do you provide sedan taxis for family and corporate travel?",
    answer: "Yes, sedan taxis are suitable for family travel, corporate rides, airport transfers, and business meetings."
  },
  {
    question: "Are Mumbai sedan cab fares transparent?",
    answer: "Yes, Om Sai Cab Service provides affordable and transparent pricing without hidden charges."
  },
  {
    question: "Is advance booking available for sedan cab service?",
    answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel schedules."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal More",
    feedback: "Used Om Sai Cab Service for a sedan cab in Mumbai and had a very comfortable experience. The car was clean, well-maintained, and perfect for city travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Jadhav",
    feedback: "Booked a sedan cab service in Mumbai with Om Sai Cab Service and everything was smooth. The driver was professional and the ride was relaxed even in traffic.",
    rating: 5
  }
];












    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai to Goa Cab", link: "Mumbai-to-Goa-Cab" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Goa Cab Booking", link: "Mumbai-to-Goa-Cab-Booking" },
        { place: "/images/keyword/3.jpg", text: "Navi Mumbai to Goa Cab Service", link: "Navi-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/4.jpg", text: "Mumbai Airport to Goa Cab", link: "Mumbai-Airport-to-Goa-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Goa Cab Service", link: "Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Best Mumbai to Goa Cab Service", link: "Best-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/7.jpg", text: "Thane to Goa Cabs", link: "Thane-to-Goa-Cabs" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Goa Innova Crysta Cab", link: "Mumbai-to-Goa-Innova-Crysta-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Goa One Way Cab", link: "Mumbai-to-Goa-One-Way-Cab" },
        { place: "/images/keyword/10.jpg", text: "Goa Cabs Service", link: "Goa-Cabs-Service" },
        { place: "/images/keyword/11.jpg", text: "Goa to Mumbai Cab", link: "Goa-to-Mumbai-Cab" },
        { place: "/images/keyword/12.jpg", text: "Goa to Navi Mumbai Cab", link: "Goa-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/13.jpg", text: "Goa to Mumbai Airport Cab", link: "Goa-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/14.jpg", text: "Goa to Mumbai One Way Cab", link: "Goa-to-Mumbai-One-Way-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/16.jpg", text: "Lonavala to Mumbai Cab", link: "Lonavala-to-Mumbai-Cab" },
        { place: "/images/keyword/17.jpg", text: "Best Lonavala to Navi Mumbai Cab", link: "Best-Lonavala-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/18.jpg", text: "Navi Mumbai Airport Cab", link: "Navi-Mumbai-Airport-Cab" },
        { place: "/images/keyword/19.jpg", text: "Navi Mumbai Cab Service", link: "Navi-Mumbai-Cab-Service" },
        { place: "/images/keyword/20.jpg", text: "Kharghar Taxi Services", link: "Kharghar-Taxi-Services" },
        { place: "/images/keyword/21.jpg", text: "Mumbai Airport Cabs", link: "Mumbai-Airport-Cabs" },
        { place: "/images/keyword/22.jpg", text: "Mumbai Cab Service", link: "Mumbai-Cab-Service" },
        { place: "/images/keyword/23.jpg", text: "Mumbai Online Cab Service", link: "Mumbai-Online-Cab-Service" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/25.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/26.jpg", text: "Innova Crysta On Rent in Mumbai", link: "Innova-Crysta-On-Rent-in-Mumbai" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sedan Cab Service Mumbai",
  "image": "http://www.omsaicabservice.com/assets/images/sedan-cab-service-mumbai.jpg",
  "description": "Book sedan cab service in Mumbai with Om Sai Cab Service for local, airport, and outstation travel. Affordable and premium Sedan taxis including Swift Dzire, Honda City, and luxury sedans available with 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Om Sai Cab Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "http://www.omsaicabservice.com/sedan-cab-service-mumbai"
  }
};




    return (
        <div>

<Helmet>
  <title>
    Sedan Cab Service Mumbai | Airport & Outstation Taxi | +91 9594849797
  </title>

  <meta
    name="description"
    content="Book sedan cab service in Mumbai for airport transfers, local rides, and outstation travel. Honda City, Swift Dzire, and luxury sedan cabs available at affordable prices with driver service."
  />

  <meta
    name="keywords"
    content="Sedan Cab Service Mumbai, Mumbai Sedan Cab Service, Sedan Taxi Service Mumbai, Sedan Cab Booking Mumbai, Luxury Sedan Cab Mumbai, Mumbai Sedan Taxi, Outstation Sedan Cab Mumbai, Mumbai Airport Sedan Cab, Honda City Cab Service Mumbai, Honda City Taxi Mumbai, Honda City on Rent Mumbai, Honda City Airport Cab Mumbai, Honda City Outstation Cab Mumbai, Luxury Honda City Cab Mumbai, Honda City Cab Booking Mumbai, Mumbai Honda City Rental, Premium Sedan Cab Mumbai, Swift Dzire Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FFCC00', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Om Sai Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Om Sai Cab</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Om Sai Cab </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                             <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919594849797" className="pc-call">+91 9594849797</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919594849797"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919594849797" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@omsaicabservice.com" className="pc-email">
                                            booking@omsaicabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Om Sai Cab Service</strong><br />
                                            Shree Vishal CHS Ltd., Plot No.17,
                                            Sector 18, Kopar Khairane, Navi Mumbai,
                                            Maharashtra- India - 400709
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Sedancabservicemumbai;